import { isValidURL } from 'helpers';

const addSocialFollowLinkTrait = (editor, { socialFollowLinkTraitType }) => {
  editor.TraitManager.addType(socialFollowLinkTraitType, {
    eventCapture: ['input'],
    onEvent({ elInput, component }) {
      const { value } = elInput;
      const { network } = component.getAttributes();

      let href = '#';

      if (!isValidURL(value)) {
        if (network) {
          if (network === 'facebook') {
            href = 'https://www.facebook.com/' + value;
          }
          if (network === 'x') {
            href = 'http://x.com/' + value;
          }
          if (network === 'vk') {
            href = 'https://vk.com/' + value;
          }
          if (network === 'instagram') {
            href = 'https://instagram.com/' + value;
          }
          if (network === 'linkedin') {
            href = 'https://linkedin.com/' + value;
          }
          if (network === 'youtube') {
            href = 'https://youtube.com/' + value;
          }
          if (network === 'pinterest') {
            href = 'https://pinterest.com/' + value;
          }
        }
      } else {
        href = value;
      }

      component.addAttributes({ href, target: '_blank' });
    },
  });
};

export default (editor, config) => {
  addSocialFollowLinkTrait(editor, config);
};
